<template>
    <AndroidButton class="JNSearchButt" @clicked="$emit('clicked')" radius="0.4em" :style="{color:selected ? 'rgb(238, 64, 64)' : '#212121'}">
        <svg
            width="799.375"
            height="682.65625"
            viewBox="0 0 19.984375 17.066406"
            version="1.1">
            <g
                id="layer1"
                transform="translate(-0.0078125,-2.0039062)">
            <path
                d="m 4.7402344,2.0039062 -0.5214844,0.056641 -0.5117188,0.109375 -0.5,0.1601562 L 2.7304688,2.5429688 2.2773438,2.8066406 1.8554688,3.1132812 1.4667969,3.4628906 1.1132812,3.8515625 0.80664062,4.2753906 0.546875,4.7285156 0.33398438,5.2070312 0.16992188,5.7050781 0.0625,6.2167969 0.0078125,6.7363281 V 7.2617188 L 0.0625,7.7832031 0.16992188,8.2929688 0.33398438,8.7910156 0.546875,9.2695312 0.80664062,9.7207031 1.1132812,10.146484 l 0.3535157,0.388672 8.53125,8.535156 8.5351561,-8.535156 0.349609,-0.388672 L 19.193359,9.7207031 19.453125,9.2695312 19.666016,8.7910156 19.830078,8.2929688 19.9375,7.7832031 19.99219,7.2617188 V 6.7363281 L 19.9375,6.2167969 19.830078,5.7050781 19.666016,5.2070312 19.453125,4.7285156 19.193359,4.2753906 18.882812,3.8515625 18.533203,3.4628906 18.144531,3.1132812 17.722656,2.8066406 17.267578,2.5429688 16.789062,2.3300781 16.292969,2.1699219 15.78125,2.0605469 15.259766,2.0039062 H 14.738281 L 14.21875,2.0605469 13.705078,2.1699219 13.207031,2.3300781 12.728516,2.5429688 12.277344,2.8066406 11.853516,3.1132812 11.464844,3.4628906 9.9980469,4.9296875 8.5351562,3.4628906 8.1464844,3.1132812 7.7226562,2.8066406 7.2695312,2.5429688 6.7910156,2.3300781 6.2949219,2.1699219 5.78125,2.0605469 5.2617188,2.0039062 Z m 0.017578,1.0019532 h 0.4824219 l 0.4824218,0.058594 0.4667969,0.1152344 0.4511719,0.1738281 0.4296875,0.2226563 0.3964844,0.2734375 0.3613281,0.3203125 2.1699219,2.171875 2.1738282,-2.171875 0.361328,-0.3203125 0.396485,-0.2734375 0.429687,-0.2226563 0.451172,-0.1738281 0.466797,-0.1152344 0.482422,-0.058594 h 0.480468 l 0.480469,0.058594 0.466797,0.1152344 0.453125,0.1738281 0.427734,0.2226563 0.396485,0.2734375 0.363281,0.3203125 0.320313,0.3632812 0.273437,0.3964844 0.224609,0.4277344 0.171875,0.4511719 0.115235,0.46875 0.05664,0.4804687 V 7.2402344 L 18.933594,7.71875 18.818359,8.1894531 18.646484,8.6425781 18.421875,9.0703125 18.148438,9.4667969 17.828125,9.8261719 9.9980469,17.65625 2.171875,9.8261719 1.8515625,9.4667969 1.5761719,9.0703125 1.3535156,8.6425781 1.1816406,8.1894531 1.0664062,7.71875 1.0097656,7.2402344 V 6.7578125 L 1.0664062,6.2773438 1.1816406,5.8085938 1.3535156,5.3574219 1.5761719,4.9296875 1.8515625,4.5332031 2.171875,4.1699219 2.5332031,3.8496094 2.9316406,3.5761719 3.3574219,3.3535156 3.8085938,3.1796875 4.2792969,3.0644531 Z"
                style="fill:#222222;fill-opacity:1;stroke:none;stroke-width:0px"
                :style="{fill:selected ? 'rgb(238, 64, 64)' : '#212121'}"
                id="path2" />
            </g>
        </svg>
    </AndroidButton>
</template>
<style>
.JNSearchButt {
    padding: 0px;
}
.JNSearchButt > svg {
  height: 23px;
  width: 23px;
}
</style>
<script>
  export default {
  name: 'favorite1',
  props: {
      selected: {
          type: Boolean,
          default:false
      }
  },
  emits:["clicked"],
}
</script>
